import ProductActionTypes from './product.types'

export const setProductItem = (item) => ({
    type: ProductActionTypes.SET_PRODUCT_ITEM,
    payload: item
})

